import { TextOutput } from 'Components/Core';
import { Field } from 'Components/Core/Field';
import { withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { ListFieldSection } from 'Components/Layout';
import { FormatTypes } from 'Lib/Format';
import { useSelector } from 'react-redux';
import './WorkOrderHeader.scss';

let WorkOrderHeader: React.FC = () => {
  const header = useSelector((state) => state.agsWorkOrderExport.workOrderDetails);

  return (
    <>
      {!window.qest.isFrame && (
        <header className="WorkOrderHeader">
          <section className="WorkOrderHeader-Headings">
            <span className="WorkOrderHeader-Heading WorkOrderHeader-Heading-smallHide">
              AGS Data for {header.WorkOrderId}
            </span>
            <div className="WorkOrderHeader-Heading WorkOrderHeader-Heading-largeHide">
              <span>{header.WorkOrderId}</span>
            </div>
          </section>

          <div className="WorkOrderHeader-Fields">
            <ListFieldSection>
              <Field input={<TextOutput />} label="Project" value={header.ProjectName} />
              <Field input={<TextOutput />} label="Client" value={header.ClientName} />
              <Field
                input={<TextOutput />}
                label="Work Date"
                value={header.WorkDate}
                format={{ type: FormatTypes.Date }}
              />
              <Field
                input={<TextOutput />}
                label="AGS Export Configuration"
                value={header.AgsExportConfigurationName}
              />
            </ListFieldSection>
          </div>
        </header>
      )}
    </>
  );
};

WorkOrderHeader = withInjectedProps(WorkOrderHeader);

export { WorkOrderHeader };
export default WorkOrderHeader;
